(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('IceProductLookup', IceProductLookup);

  IceProductLookup.$inject = ['$resource', 'API_URI'];

  function IceProductLookup($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_lookup/all-products';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
